import React, { useEffect, useState } from 'react';
import './styles/header.css';
import logo from '../images/BPLogo.png';
import CTAButton from './CTAButton';
import CTAButton2 from './CTAButton2';
import PhoneMenu from './phoneMenu';
import { Link, useLocation } from 'react-router-dom';

function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isTop, setIsTop] = useState(true);
  const [prevScrollPos, setPrevScrollPos] = useState(0);
  const [visible, setVisible] = useState(true);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const location = useLocation();
  const isActivePage = (path) => location.pathname === path;
  const isKursusPage = location.pathname.includes('/kursus');
  const isAdminPage = location.pathname.includes('/admin');

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollPos = window.scrollY;
      
      setIsTop(currentScrollPos < 50);
      setVisible(prevScrollPos > currentScrollPos || currentScrollPos < 50);
      setPrevScrollPos(currentScrollPos);
      setIsScrolled(currentScrollPos > 50);
    };

    const handleResize = () => {
      if (window.innerWidth > 1375 && isMenuOpen) {
        setIsMenuOpen(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleResize);
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleResize);
    };
  }, [prevScrollPos, isMenuOpen]);

  return (
    <header className={`header 
      ${isScrolled ? 'scrolled' : ''} 
      ${!visible ? 'hidden' : ''} 
      ${isTop && !isKursusPage && !isAdminPage ? 'top' : ''} 
      ${(isKursusPage || isAdminPage) ? 'fixed-header' : ''}`}>
      <div className="logo-container">
        <Link to="/">
          <img src={logo} alt="Byggeriets Partner Logo" className="logo" />
        </Link>
      </div>
      
      {/* Desktop Menu */}
      <nav className="nav-menu desktop-menu">
        <Link to="/" className={isActivePage('/') ? 'active' : ''}>Forside</Link>
        <Link to="/kvalitetssikring" className={isActivePage('/kvalitetssikring') ? 'active' : ''}>Kvalitetssikring</Link>
        <Link to="/drift-og-vedligeholdelse" className={isActivePage('/drift-og-vedligeholdelse') ? 'active' : ''}>Drift & Vedligeholdelse</Link>
        <Link to="/referencer" className={isActivePage('/referencer') ? 'active' : ''}>Referencer</Link>
        <Link to="/om" className={isActivePage('/om') ? 'active' : ''}>Om</Link>
        <Link to="/kursus">
          <CTAButton text="Kurser" />
        </Link>
        <Link to="/kontakt">
          <CTAButton2 text="Kontakt" />
        </Link>
      </nav>

      {/* Burger Menu Button */}
      <button 
        className={`burger-menu ${isMenuOpen ? 'open' : ''}`}
        onClick={() => setIsMenuOpen(!isMenuOpen)}
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      {/* Mobile Menu */}
      <PhoneMenu isOpen={isMenuOpen} onClose={() => setIsMenuOpen(false)} />
    </header>
  );
}

export default Header;
